<template>
    <div class="notification" v-if="visible">
        <div class="notification__text">
           {{text}}
        </div>
        <div class="notification__link" v-if="link">
            <a :href="link" class="btn btn-sm btn-outline-light">
                <span v-if="linkText">{{linkText}}</span>
                <span v-else>Read More</span>
            </a>
        </div>
        <a href="#close" class="notification__close" v-on:click="hide()">
            <span></span>
            <span></span>
        </a>
    </div>
</template>

<script>
    import * as Cookies from 'js-cookie';

    export default {
        props: ['text', 'link', 'linkText'],
        data() {
            return {
                visible: true
            }
        },
        mounted() {
            if (Cookies.get('notification-hidden')) this.visible = false;
            console.log(Cookies.get('notification-hidden'));
        },
        methods: {
            hide() {
                this.visible = false;
                Cookies.set('notification-hidden', true, {expires: 2});
            }
        }
    }
</script>